module.exports = __webpack_public_path__ + "static/media/menu-hamburger.7f899510.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/menu-hamburger.svg
// module id = 845
// module chunks = 21